import React, { useEffect, useState } from 'react';
import { FolderOpen } from 'lucide-react';
import { API, isNewResource } from './resourceLibraryApi';
import { ResourceFileRow } from './ResourceFileRow';
import { ResourceViewerDialog } from './ResourceViewerDialog';

export const StudentResourceLibrary = ({ subject, yearLevel, token }) => {
  const [files, setFiles] = useState([]);
  const [viewId, setViewId] = useState(null);

  useEffect(() => {
    if (!subject || !yearLevel || !token) return;
    fetch(`${API}/api/resource-library?subject=${encodeURIComponent(subject)}&year_level=${yearLevel}&token=${token}`)
      .then((r) => (r.ok ? r.json() : { resources: [] }))
      .then((d) => setFiles([...(d.resources || [])].sort((a, b) => Number(isNewResource(b)) - Number(isNewResource(a)))))
      .catch(() => setFiles([]));
  }, [subject, yearLevel, token]);

  if (!files.length) return null;
  const newCount = files.filter(isNewResource).length;

  return (
    <div className={`mb-6 rounded-xl border p-4 ${newCount ? 'border-amber-300 bg-amber-50/60' : 'border-emerald-200 bg-emerald-50/50'}`} data-testid="student-resource-library">
      <div className="flex items-center gap-2 mb-3 flex-wrap">
        <FolderOpen className="h-5 w-5 text-emerald-700" />
        <h3 className="font-semibold text-emerald-900">Downloads — Year {yearLevel} {subject}</h3>
        {newCount > 0 && <span className="text-xs font-semibold rounded-full bg-amber-400 text-amber-950 px-2 py-0.5" data-testid="student-resource-new-count">{newCount} new this fortnight</span>}
      </div>
      <p className="text-sm text-emerald-800/80 mb-3">Click a document to read it here, or download it to study offline.</p>
      <div className="space-y-2">
        {files.map((f) => <ResourceFileRow key={f.id} res={f} token={token} onOpen={(r) => setViewId(r.id)} />)}
      </div>
      {viewId && <ResourceViewerDialog resources={files} initialId={viewId} token={token} onClose={() => setViewId(null)} />}
    </div>
  );
};
